import { path } from './helpers'
import Vue from 'vue'
import domains from '_static/domains.json'

const api = Vue.prototype.$api
function landingPath (resource) {
  return path(`/Landings/${resource}`)
}

export default {
  getLandingData (host = null) {
    let params = {
      host: host || (window.location.host.includes('localhost') ? domains.landingTestUrl : window.location.host)
    }
    return api.get(landingPath('CustomLanding'), { params: params })
  }
}


// WEBPACK FOOTER //
// ./src/repositories/LandingsRepository.js